'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _STR_UNDEFINED = require('permanent/es/STR_UNDEFINED');

var _STR_UNDEFINED2 = _interopRequireDefault(_STR_UNDEFINED);

var _typeOf = require('./typeOf');

var _typeOf2 = _interopRequireDefault(_typeOf);

var _equals = require('./equals');

var _equals2 = _interopRequireDefault(_equals);

var _compose = require('./compose');

var _compose2 = _interopRequireDefault(_compose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Determine if value is undefined
 *
 * @module isUndefined
 * @func
 * @since 1.0.0
 * @param {*} val
 * @return {boolean}
 * @example
 *
 *     isUndefined(undefined); //=> true
 *     isUndefined(true); //=> false
 */

var equalsUndefined = (0, _equals2.default)(_STR_UNDEFINED2.default);
var isUndefined = (0, _compose2.default)(equalsUndefined, _typeOf2.default);

exports.default = isUndefined;